export const mediaQueriesConfig = {
  screenSM: '576px',
  screenMD: '768px',
  screenLG: '992px',
  screenXL: '1200px',
  screenXXL: '1400px',
};

export const mediaQueriesMaxPxConfig = {
  screenSM: 575,
  screenMD: 768,
  screenLG: 991,
  screenXL: 1199,
  screenXXL: 1399,
};
